
import Vue from 'vue'

export default Vue.extend({
  seo: {
    title: 'PomoFocus Pomodoro Timer | Aaron Cunliffe',
    description: 'PomoFocus is a simple Go terminal Pomodoro timer built with Bubble Tea and Charmbracelet libraries for deep focus sessions.'
  }
})
